import LazyLoad from "vanilla-lazyload/dist/lazyload.js";
import { LAZY_LOAD_CONFIG } from "../config.js";

const $ = require("jquery");

function setQueryParameter(uri, key, value) {
  var re = new RegExp("([?&])(" + key + "=)[^&#]*", "g");

  if (uri.match(re)) {
    return uri.replace(re, "$1$2" + value);
  }

  var paramString = (uri.indexOf("?") < 0 ? "?" : "&") + key + "=" + value;
  var hashIndex = uri.indexOf("#");

  if (hashIndex < 0) {
    return uri + paramString;
  } else {
    return uri.substring(0, hashIndex) + paramString + uri.substring(hashIndex);
  }
}

export function updateContent(name, val) {
  const uri = window.location.href;
  const url = setQueryParameter(uri, name, val);

  window.history.pushState({}, null, url);

  $(".archive-content").load(
    url + " .archive-content .archive-content__wrapper",
    function() {
      new LazyLoad(LAZY_LOAD_CONFIG);
    }
  );
}
